module.exports = __webpack_public_path__ + "img/timeline.35fb905b.svg";